module.exports = __webpack_public_path__ + "img/des7.8a2da301.png";